document.addEventListener('DOMContentLoaded', function() {
  console.log('Language selector script loaded');
  
  // Desktop language selector
  const desktopSelectTrigger = document.getElementById('custom-select-trigger');
  const desktopSelectWrapper = document.querySelector('.header__menu-item--country .custom-select-wrapper');
  
  if (desktopSelectTrigger && desktopSelectWrapper) {
    console.log('Desktop selector found');
    
    desktopSelectTrigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      console.log('Desktop trigger clicked');
      
      // Close mobile dropdown if open
      const mobileWrapper = document.querySelector('.custom-select-wrapper-mobile');
      if (mobileWrapper) mobileWrapper.classList.remove('open');
      
      // Toggle desktop dropdown
      desktopSelectWrapper.classList.toggle('open');
      
      // Force show dropdown if needed
      const dropdown = desktopSelectWrapper.querySelector('.custom-dropdown');
      if (dropdown && desktopSelectWrapper.classList.contains('open')) {
        dropdown.style.display = 'block';
        dropdown.style.opacity = '1';
        dropdown.style.visibility = 'visible';
      }
    });
    
    // Prevent clicks inside the dropdown from closing it
    const desktopDropdown = desktopSelectWrapper.querySelector('.custom-dropdown');
    if (desktopDropdown) {
      desktopDropdown.addEventListener('click', function(e) {
        e.stopPropagation();
      });
    }
  } else {
    console.log('Desktop selector not found:', { 
      trigger: desktopSelectTrigger, 
      wrapper: desktopSelectWrapper 
    });
  }
  
  // Mobile language selector
  const mobileSelectTrigger = document.getElementById('mobile-select-trigger');
  const mobileSelectWrapper = document.querySelector('.custom-select-wrapper-mobile');
  
  if (mobileSelectTrigger && mobileSelectWrapper) {
    console.log('Mobile selector found');
    
    mobileSelectTrigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      console.log('Mobile trigger clicked');
      
      // Close desktop dropdown if open
      const desktopWrapper = document.querySelector('.header__menu-item--country .custom-select-wrapper');
      if (desktopWrapper) desktopWrapper.classList.remove('open');
      
      // Toggle mobile dropdown
      mobileSelectWrapper.classList.toggle('open');
      
      // Force show dropdown if needed
      const dropdown = mobileSelectWrapper.querySelector('.custom-dropdown');
      if (dropdown && mobileSelectWrapper.classList.contains('open')) {
        dropdown.style.display = 'block';
        dropdown.style.opacity = '1';
        dropdown.style.visibility = 'visible';
      }
    });
    
    // Prevent clicks inside the dropdown from closing it
    const mobileDropdown = mobileSelectWrapper.querySelector('.custom-dropdown');
    if (mobileDropdown) {
      mobileDropdown.addEventListener('click', function(e) {
        e.stopPropagation();
      });
    }
  } else {
    console.log('Mobile selector not found:', { 
      trigger: mobileSelectTrigger, 
      wrapper: mobileSelectWrapper 
    });
  }
  
  // Close all dropdowns when clicking outside
  document.addEventListener('click', function() {
    if (desktopSelectWrapper) {
      desktopSelectWrapper.classList.remove('open');
    }
    if (mobileSelectWrapper) {
      mobileSelectWrapper.classList.remove('open');
    }
  });
});
